<template>
  <div class="flex w-full flex-col items-start">
    <SFHeadline class="mb-10 font-sans !font-normal text-gray-600" size="lg">
      {{ $t('product_list_no_results.description') }}
    </SFHeadline>
    <div
      class="flex flex-wrap items-center justify-start gap-4 max-sm:flex-col"
    >
      <SFButton
        v-if="category"
        size="md"
        class="max-sm:w-full"
        :to="
          isBrandsPage
            ? localePath(routeList.brands.path)
            : buildCategoryPath(category)
        "
      >
        <template #icon>
          <IconChevronLeft class="size-3.5" />
        </template>
        {{
          $t('product_list_no_results.back_to_category', {
            category: category.name,
          })
        }}
      </SFButton>
      <SFButton
        v-if="areFiltersApplied"
        variant="secondary"
        size="md"
        class="max-sm:w-full"
        @click="resetFilters"
      >
        {{ $t('product_list_no_results.reset_filters') }}
      </SFButton>
    </div>

    <SFTopBrands v-if="!category" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Category } from '@scayle/storefront-nuxt'
import { useRouteHelpers, useFilter } from '~/composables'
import { SFButton, SFHeadline } from '#storefront-ui/components'
import { useAppliedFilters } from '#storefront-product-listing'
import { useRoute } from '#app/composables/router'
import SFTopBrands from '~/components/SFTopBrands.vue'
import { routeList } from '~/utils/route'
import { useLocalePath } from '#i18n'

const { path } = useRoute()
const localePath = useLocalePath()

const route = useRoute()
const { category } = defineProps<{ category?: Category }>()

const isBrandsPage = computed(
  () => category?.slug === 'brands' && path.includes('/b/'),
)

const currentCategoryId = computed(
  () => Number(route.params?.id) || category?.id,
)

const { buildCategoryPath } = useRouteHelpers()

const { resetFilters } = await useFilter(currentCategoryId?.value, {
  immediate: false,
})

const { areFiltersApplied } = useAppliedFilters(useRoute())
</script>
